import React, { createContext } from "react";
import { isDevEnv } from "../devMessage/index";
export var createNamedContext = function(name, initialValue) {
    var NamedContext = createContext(initialValue);
    if (isDevEnv()) {
        NamedContext.displayName = name;
    }
    return NamedContext;
};
export default createNamedContext;
